<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Configuration</h3>

    <lib-signal-text-field label="Label" [formField]="configForm.label" />
    <lib-signal-text-field label="Placeholder" [formField]="configForm.placeholder" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the field"
      [formField]="configForm.helpText" />
  </section>

  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Validators</h3>

    <lib-signal-checkbox
      label="Required"
      hint="Respondent must fill this field"
      [formField]="configForm.required" />

    <lib-signal-text-field
      label="Custom error message"
      placeholder="Shown when validation fails"
      [formField]="configForm.customMessage" />
  </section>
</form>
